import * as yup from 'yup';
import '../methods/numbersOnly'; // used by account number, routing number
import '../methods/or'; // used by account number (ZA)

const stringSchema = yup.string().trim();

const accountNumberSchema = stringSchema
  .required('Please enter an account number')
  .numbersOnly('Please enter only digits');

const today = new Date(Date.now());

export const recipientSchema = {
  firstName: stringSchema.required('Please enter a first name'),
  middleName: stringSchema.optional(),
  lastName: stringSchema.required('Please enter a last name'),
  bankCode: stringSchema.required('Please choose a bank'),
  bankCodeGhMobile: stringSchema.required('Please choose a mobile operator'),
  branchCode: stringSchema.required('Please choose a bank branch'),
  accountNumberNG: accountNumberSchema.length(10, `\${length} digits required`),
  // accountNumberGH: accountNumberSchema.length(13, `\${length} digits required`),
  // accountNumberGH: accountNumberSchema.length(13, `\${length} digits required`),
  accountNumberGH: accountNumberSchema.or(
    [
      accountNumberSchema.length(10),
      accountNumberSchema.length(11),
      accountNumberSchema.length(12),
      accountNumberSchema.length(13),
      accountNumberSchema.length(14)
    ],
    'Please enter 10 to 14 digits'
  ),
  accountNumberZA: accountNumberSchema.or(
    [accountNumberSchema.length(9), accountNumberSchema.length(10), accountNumberSchema.length(11)],
    'Please enter 9 to 11 digits'
  ),
  accountNumberKE: accountNumberSchema.or(
    [
      accountNumberSchema.length(9),
      accountNumberSchema.length(10),
      accountNumberSchema.length(11),
      accountNumberSchema.length(12),
      accountNumberSchema.length(13),
      accountNumberSchema.length(14)
    ],
    'Please enter 9 to 14 digits'
  ),
  accountNameNG: stringSchema.required('Please enter account name'),
  routingNumber: stringSchema
    .required('Please enter a routing number')
    .numbersOnly('Please enter only digits')
    .length(9, 'Please enter 9 digits'),
  address: stringSchema.required('Please enter an address'),
  city: stringSchema.required('Please enter a city'),
  emailRequired: stringSchema.required('Please enter an email').email('Please enter a valid email'),
  emailOptional: stringSchema.email('Please enter a valid email'),
  mobileOperator: stringSchema.required('Please choose a mobile operator'),
  birthday: yup.date().max(today, 'The maximum date to be selected is today'),
  country: stringSchema.required('Please choose a country')
};
